import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/marketing/Navigation'
import Footer from '../components/marketing/Footer'

export default function Home() {
  return (
    <div className="font-body text-brand-charcoal bg-white min-h-screen flex flex-col selection:bg-brand-green selection:text-white">
      <Navbar />

      {/* Hero Section - Cleaner with focused messaging */}
      <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 overflow-hidden bg-gradient-to-b from-brand-cream/40 to-white">
        {/* Decorative background blobs - simplified */}
        <div className="absolute top-20 right-0 w-96 h-96 bg-brand-amber/10 rounded-full blur-3xl -z-10"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-brand-green/8 rounded-full blur-3xl -z-10"></div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

            {/* Content Side */}
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-brand-green/10 text-brand-green font-semibold text-sm tracking-wide border border-brand-green/20">
                Minnesota Youth Hockey
              </div>
              <h1 className="font-heading text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight text-brand-charcoal mb-6">
                Find scrimmages in<br className="hidden lg:block" />
                <span className="text-brand-green">minutes, not hours</span>
              </h1>
              <p className="text-xl text-brand-slate leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
                We scan 200+ association calendars across Minnesota to find teams with open ice—matched to your level, location, and schedule.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
                <Link
                  to="/scrimmages/bulletin"
                  className="w-full sm:w-auto px-8 py-4 bg-brand-green text-white rounded-xl font-bold hover:bg-brand-green/90 transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 text-center"
                >
                  Find Your Next Scrimmage
                </Link>
                <Link
                  to="/claim-team"
                  className="w-full sm:w-auto px-8 py-4 bg-white text-brand-green border-2 border-brand-green/20 rounded-xl font-bold hover:border-brand-green/40 hover:bg-brand-green/5 transition-all text-center"
                >
                  List Your Open Ice
                </Link>
              </div>
              <p className="mt-6 text-sm text-brand-slate/80">
                Free to search and post. No account required to browse.
              </p>
            </div>

            {/* Visual Side - Scrimmage Finder Demo */}
            <div className="w-full lg:w-1/2 relative">
              <div className="relative z-10 bg-white rounded-2xl shadow-2xl border border-brand-border p-5 transform rotate-1 hover:rotate-0 transition-transform duration-500">

                {/* Header: Your Team */}
                <div className="flex items-center justify-between mb-5 pb-4 border-b border-gray-100">
                  <div className="flex items-center space-x-3">
                    <div className="w-11 h-11 rounded-xl bg-brand-green flex items-center justify-center text-white font-bold shadow-md">EP</div>
                    <div>
                      <div className="font-bold text-brand-charcoal">Eden Prairie Peewee A</div>
                      <div className="text-xs text-brand-slate">Matches for this week</div>
                    </div>
                  </div>
                  <div className="px-2.5 py-1 bg-green-50 text-green-700 rounded-lg text-xs font-bold border border-green-200">
                    3 Found
                  </div>
                </div>

                {/* Label */}
                <p className="text-[11px] uppercase tracking-wider font-bold text-brand-slate mb-3">
                  Peewee A teams with solo ice near you:
                </p>

                {/* Scrimmage Matches */}
                <div className="space-y-2.5">
                  {/* Match 1 - 94% */}
                  <div className="flex items-center p-3 bg-green-50 rounded-lg border border-green-200 cursor-pointer hover:border-green-400 transition-colors">
                    <div className="w-10 h-10 bg-white rounded-lg border border-green-200 flex flex-col items-center justify-center mr-3 shadow-sm">
                      <span className="text-[9px] uppercase font-bold text-green-600">Jan</span>
                      <span className="text-sm font-bold text-brand-charcoal leading-none">11</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-bold text-brand-charcoal text-sm">Edina Peewee A</div>
                      <div className="text-xs text-gray-500">Solo ice • You're free • 6 mi</div>
                    </div>
                    <div className="text-right">
                      <span className="block text-[10px] font-bold text-white bg-brand-green px-2.5 py-1 rounded-full">94%</span>
                    </div>
                  </div>

                  {/* Match 2 - 87% */}
                  <div className="flex items-center p-3 bg-white rounded-lg border border-gray-100 cursor-pointer hover:border-brand-green/30 transition-colors">
                    <div className="w-10 h-10 bg-gray-50 rounded-lg border border-gray-200 flex flex-col items-center justify-center mr-3">
                      <span className="text-[9px] uppercase font-bold text-gray-400">Jan</span>
                      <span className="text-sm font-bold text-gray-600 leading-none">14</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-bold text-brand-charcoal text-sm">Wayzata Peewee A</div>
                      <div className="text-xs text-gray-500">Solo ice • You're free • 13 mi</div>
                    </div>
                    <div className="text-right">
                      <span className="block text-[10px] font-bold text-white bg-brand-amber px-2.5 py-1 rounded-full">87%</span>
                    </div>
                  </div>

                  {/* Match 3 - 72% */}
                  <div className="flex items-center p-3 bg-white rounded-lg border border-gray-100 cursor-pointer hover:border-brand-green/30 transition-colors">
                    <div className="w-10 h-10 bg-gray-50 rounded-lg border border-gray-200 flex flex-col items-center justify-center mr-3">
                      <span className="text-[9px] uppercase font-bold text-gray-400">Jan</span>
                      <span className="text-sm font-bold text-gray-600 leading-none">18</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-bold text-brand-charcoal text-sm">Minnetonka Peewee A</div>
                      <div className="text-xs text-gray-500">Likely solo • Tight fit • 6 mi</div>
                    </div>
                    <div className="text-right">
                      <span className="block text-[10px] font-bold text-gray-600 bg-gray-200 px-2.5 py-1 rounded-full">72%</span>
                    </div>
                  </div>
                </div>

                <div className="mt-4 pt-3 border-t border-gray-100 flex items-center justify-between">
                  <span className="text-xs text-gray-400">Scores: Solo ice + Schedule + Distance</span>
                  <Link to="/scrimmages/bulletin" className="text-brand-green font-bold text-sm hover:underline">
                    View all →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coverage Badge - Simplified */}
      <div className="border-y border-gray-100 bg-white py-8">
        <div className="container mx-auto px-6 text-center">
          <p className="text-sm font-medium text-brand-slate">
            Scanning calendars across all <span className="font-bold text-brand-charcoal">13 Minnesota Hockey districts</span> — updated hourly
          </p>
        </div>
      </div>

      {/* Progressive Journey: Find → Connect → Manage */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="font-heading text-3xl lg:text-4xl font-bold text-brand-charcoal mb-4">
              From scattered search to organized team
            </h2>
            <p className="text-lg text-brand-slate">
              Whether you just need a scrimmage or want to streamline your whole season, we've got you covered.
            </p>
          </div>

          {/* Three-step journey */}
          <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">

            {/* Step 1: Find */}
            <div className="relative bg-white rounded-2xl p-8 border border-gray-100 shadow-lg hover:shadow-xl transition-shadow">
              <div className="absolute -top-4 left-8">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-brand-green text-white font-bold text-sm">1</span>
              </div>
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-brand-green/10 text-brand-green mb-5">
                <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <h3 className="font-heading text-xl font-bold text-brand-charcoal mb-3">Find Open Ice</h3>
              <p className="text-brand-slate leading-relaxed mb-4">
                Browse scrimmage opportunities from teams across Minnesota. Filter by level, distance, and date. No more scrolling Facebook groups.
              </p>
              <ul className="space-y-2 text-sm text-brand-slate">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-brand-green mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  200+ calendars scanned hourly
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-brand-green mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  Match scores based on compatibility
                </li>
              </ul>
              <div className="mt-6 pt-4 border-t border-gray-100">
                <span className="inline-block px-3 py-1 bg-brand-green/10 text-brand-green text-xs font-bold rounded-full">
                  Always Free
                </span>
              </div>
            </div>

            {/* Step 2: Connect */}
            <div className="relative bg-white rounded-2xl p-8 border border-gray-100 shadow-lg hover:shadow-xl transition-shadow">
              <div className="absolute -top-4 left-8">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-brand-green text-white font-bold text-sm">2</span>
              </div>
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-brand-green/10 text-brand-green mb-5">
                <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <h3 className="font-heading text-xl font-bold text-brand-charcoal mb-3">Connect Directly</h3>
              <p className="text-brand-slate leading-relaxed mb-4">
                Request scrimmages with one click. Get notified when teams match your criteria. Claim your team to post your own open ice.
              </p>
              <ul className="space-y-2 text-sm text-brand-slate">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-brand-green mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  One-click scrimmage requests
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-brand-green mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  Email alerts for new matches
                </li>
              </ul>
              <div className="mt-6 pt-4 border-t border-gray-100">
                <span className="inline-block px-3 py-1 bg-brand-green/10 text-brand-green text-xs font-bold rounded-full">
                  Free to Start
                </span>
              </div>
            </div>

            {/* Step 3: Manage */}
            <div className="relative bg-gradient-to-br from-brand-charcoal to-gray-800 rounded-2xl p-8 border border-brand-charcoal shadow-lg hover:shadow-xl transition-shadow text-white">
              <div className="absolute -top-4 left-8">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-brand-amber text-white font-bold text-sm">3</span>
              </div>
              <div className="absolute top-4 right-4">
                <span className="inline-block px-2 py-0.5 bg-brand-amber text-white text-[10px] font-bold rounded uppercase tracking-wider">
                  Pro
                </span>
              </div>
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-white/10 text-white mb-5 mt-2">
                <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="font-heading text-xl font-bold text-white mb-3">Manage Your Season</h3>
              <p className="text-brand-cream/80 leading-relaxed mb-4">
                Tired of Sunday night email chaos? AI generates weekly parent updates from your notes. Searchable wiki keeps everyone informed.
              </p>
              <ul className="space-y-2 text-sm text-brand-cream/90">
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-brand-amber mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  AI-powered weekly dispatches
                </li>
                <li className="flex items-center">
                  <svg className="w-4 h-4 text-brand-amber mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  Team portal with auto-wiki
                </li>
              </ul>
              <div className="mt-6 pt-4 border-t border-white/10">
                <Link to="/pricing" className="inline-flex items-center text-brand-amber font-bold text-sm hover:underline">
                  $49/season — See details
                  <svg className="w-4 h-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works - Simplified */}
      <section id="how-it-works" className="py-20 bg-brand-cream/30 border-y border-brand-border/30">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-2xl mx-auto mb-16">
            <h2 className="font-heading text-3xl font-bold text-brand-green mb-4">How scrimmage matching works</h2>
            <p className="text-brand-slate">Three steps. Two minutes. Zero Facebook scrolling.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              {
                step: "1",
                title: "We scan calendars",
                desc: "Every hour, our system checks Minnesota association calendars for solo practice slots—ice where a team practices alone."
              },
              {
                step: "2",
                title: "AI calculates matches",
                desc: "We score potential matches based on skill level, distance, schedule compatibility, and whether they're actually looking for a scrimmage."
              },
              {
                step: "3",
                title: "You connect directly",
                desc: "Click to request a scrimmage. The other manager gets notified. Confirm and you're set—no middleman needed."
              }
            ].map((item, i) => (
              <div key={i} className="text-center">
                <div className="w-14 h-14 bg-brand-green text-white rounded-2xl flex items-center justify-center font-heading font-bold text-xl mx-auto mb-5">
                  {item.step}
                </div>
                <h3 className="font-heading text-lg font-bold text-brand-charcoal mb-3">{item.title}</h3>
                <p className="text-brand-slate text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Social Proof Placeholder - Ready for when you have testimonials */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-lg text-brand-slate italic leading-relaxed">
              "We used to email five different associations to find one scrimmage. Now it takes two minutes."
            </p>
            <p className="mt-4 text-sm text-brand-charcoal font-semibold">
              — Built by hockey managers, for hockey managers
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-brand-green">
        <div className="container mx-auto px-6 text-center max-w-2xl">
          <h2 className="font-heading text-3xl lg:text-4xl font-bold text-white mb-6">
            Ready to stop scrolling Facebook groups?
          </h2>
          <p className="text-brand-cream/80 text-lg mb-8">
            Find open ice across Minnesota in seconds. Post your own availability for free.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/scrimmages/bulletin"
              className="px-8 py-4 bg-white text-brand-green rounded-xl font-bold hover:bg-brand-cream transition-colors shadow-lg"
            >
              Find Your Next Scrimmage
            </Link>
            <Link
              to="/claim-team"
              className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-xl font-bold hover:bg-white/10 transition-colors"
            >
              List Your Open Ice
            </Link>
          </div>
          <p className="mt-6 text-sm text-brand-cream/60">
            No account needed to browse. Free forever to search and post.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  )
}
